import { USER_TAGS_PARAMETER } from "helpers/constants/miscellaneous";
import { useSelector } from "react-redux";
import { FilterOption } from "types";
import MultiSelectDropDown from "views/pages/DataPage/CardsView/DataPageFilters/MultiSelectDropDown";
import FilterButton from "views/atomComponents/FilterButton";
import useUpdateQueryParameter from "hooks/useUpdateQueryParameter";
import useAmplitudeTrackFilterEvent from "hooks/useAmplitudeTrackFilterEvent";
import { State } from "redux/store";
import { getUserTags } from "redux/SingleDataset/selectors";
import useQueryParam from "hooks/useQueryParam";

const TagsFilter = () => {
  const trackFilterEvent = useAmplitudeTrackFilterEvent("User Tags", "Dataset");
  const updateQueryParameter = useUpdateQueryParameter();
  const userTagsFromQueryParam = JSON.parse(
    useQueryParam(USER_TAGS_PARAMETER) || "[]"
  );
  const tags = useSelector((state: State) =>
    getUserTags(state, userTagsFromQueryParam)
  );
  const clearTags = () => {
    const unselectedTags = tags.map((option: FilterOption) => ({
      ...option,
      selected: false,
    }));
    updateQueryParameter(unselectedTags as any, USER_TAGS_PARAMETER, "id");
  };
  const selectedTags = tags.filter((option: FilterOption) => option.selected);
  const selectedTagsId = selectedTags.map((option: FilterOption) => option.id);
  const firstTagText = selectedTags.length > 0 ? selectedTags[0].text : "";
  const tagsCountDisplayNumber =
    selectedTags?.length > 1 ? selectedTags?.length - 1 : 0;

  const handleFilterSelection = (value: number) => {
    const selectedTag = tags.find(
      (option: FilterOption) => option.id === value
    );

    if (selectedTag?.selected) {
      trackFilterEvent("Removed");
    } else {
      trackFilterEvent("Added");
    }

    let newTags = [
      ...tags.filter((option: FilterOption) => option.id !== value),
      { ...selectedTag, selected: !selectedTag?.selected },
    ];
    newTags = [
      ...newTags.filter((tag) => tag.text === "untagged"),
      ...newTags.filter((tag) => tag.text !== "untagged"),
    ];
    updateQueryParameter(newTags as any, USER_TAGS_PARAMETER, "id");
  };

  return (
    <FilterButton
      label={"User Tags"}
      selectedLabel={firstTagText}
      variant={selectedTags.length > 0 ? "selected" : "default"}
      itemCount={tagsCountDisplayNumber}
      tooltip={`Apply this filter to display only the data entries tagged with a specific User Tag you're interested in.`}
    >
      <MultiSelectDropDown
        selectedItemsIds={selectedTagsId}
        onItemSelection={handleFilterSelection}
        onClearSelection={clearTags}
        items={tags}
      />
    </FilterButton>
  );
};

export default TagsFilter;
